import script from "./Cards.vue?vue&type=script&setup=true&lang=js"
export * from "./Cards.vue?vue&type=script&setup=true&lang=js"

import "./Cards.vue?vue&type=style&index=0&id=4c4388de&lang=css"

const __exports__ = script;

export default __exports__